import type { GetContextMenuSection } from "./helpers";
import type { GridApi, IMenuActionParams } from "ag-grid-community";
import { useActivePageId, usePageProducts, useUpdatePageProducts } from "../../../data";
import { columnWidth } from "../../globals";
import { colParams } from "../../utils";
import { getIcon } from "./icons";
import { useColumnSettingsModal } from "../modals/Formatting";

export const useGetMenuItemsColumn = (): GetContextMenuSection => {
  const update = useUpdatePageProducts();
  const pageId = useActivePageId();
  const products = usePageProducts(pageId);
  const modal = useColumnSettingsModal();

  const setColumnWidthsToCurrent = async (api: GridApi, actualWidth?: number, columnId?: string, entityId?: string) => {
    const currentColumn = api?.getColumns()?.find((column) => {
      const col = colParams(column);
      return col?.gridId === columnId || col?.entityId === entityId;
    });
    const currentWidth = currentColumn?.getActualWidth() || actualWidth || columnWidth;

    const changes =
      api
        ?.getColumns()
        ?.map((column) => {
          const col = colParams(column);
          const gridId = col?.gridId;
          if (!gridId || !col?.artisType) return null;
          const current = products.data?.find((x) => (x.grid_id || x.id) === gridId);
          if (!current) return null;
          return update.optimistic({
            id: current.id,
            column_width: currentWidth,
          });
        })
        .filter(Boolean) || [];

    await Promise.all(changes);
  };

  return (ctx) => {
    const items = [
      {
        name: "Column",
        icon: getIcon("width"),
        subMenu: [
          {
            name: "Set All Column Widths to Current",
            action: (e: IMenuActionParams) => {
              setColumnWidthsToCurrent(e.api, ctx.columnWidth, ctx.columnId, ctx.entityId);
            },
          },
        ],
      },
    ];

    if (ctx.isProduct) {
      const product = products.data?.find((x) => x.id === ctx.entityId);
      if (product) {
        items[0].subMenu.unshift({
          name: "Column Settings",
          action: () => {
            modal.open({
              active: "settings",
              selection: ctx.selectedRange,
              pageId,
              type: "column",
              width: 430,
              height: 430,
            });
          },
        });
      }
    }

    return items;
  };
};
